import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Popconfirm } from "antd";

import service from "../../../../services/stemiService";
import { recordError } from "../../../../utils/logService";

import {CheckboxSwitchery,
  FormItemList,
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

const ManageOlympiadName = (props) => {
  const { record, showModal, setHasUpdated, initWidth, modalWidth, setModalWidth, modalType } = props;

  const [disabled, setDisabled] = useState(true);
  const [activeName, setActiveName] = useState(record.active);

  const isAddModal = modalType === 'Add';
  const [form] = Form.useForm();
  const entity = "Olympiad Name";
  const formName = "ManageOlympiadName";
  let msg = "";

  useEffect(() => {

    if (!isAddModal) {
      onFormLoad();
    }

    window.addEventListener('resize', () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < initWidth) {
        setModalWidth(screenWidth * 0.8);
      }
    })
  }, [record, window]);

  const onFormLoad = () => {
    form.setFieldsValue({
      name: record.name,
      id: record.id,
      active: record.enabled,
    });
  };

  const onSubmit = async (values) => {

    try {
      let response = null;
      if (isAddModal) {
        let formData = new FormData();
        values?.names.forEach((item) => {
          formData.append("name", item);
        })
        response = await service.addOlympiadNames(formData);
      } else {
        response = await service.updateOlympiadName(record.uuid, {
          name: values.name,
          enabled: values.active
        });
      }

      if (response && (response.status == 201 || response.status == 200)) {
        const msgType = isAddModal ? Messages.ADD_SUCCESS : Messages.UPDATE_SUCCESS;
        msg = util.parseMessage(msgType, entity);
        openNotification(entity, msg, Notify.SUCCESS);
        setHasUpdated(true);
        handleConfirm();
      } else {

        const msgType = isAddModal ? Messages.ADD_FAILURE : Messages.UPDATE_FAILURE;
        msg = util.parseMessage(msgType, entity);
        openNotification(entity, msg, Notify.ERROR);
      }
    } catch (error) {
      if (error && error.response.status == 409) {
        msg = util.parseMessage(Messages.CONFLICT, entity);
        openNotification(entity, msg, Notify.ERROR);
        return;
      }

      const msgType = isAddModal ? Messages.ADD_FAILURE : Messages.UPDATE_FAILURE;
      msg = util.parseMessage(msgType, entity);
      openNotification(entity, msg, Notify.ERROR);
      recordError(error);
    }
  };

  const handleConfirm = () => {
    form.resetFields();
    showModal(false);
    setDisabled(true);
  };

  const handleCancel = () => {


    if (form.getFieldValue("name")) {
      setDisabled(false);
    } else {
      handleConfirm();
    }
  };

  const onChangeActive = (checked) => {
    setActiveName(checked);
  };

  return (
    <>
      <Modal
        forceRender
        key={"modal-add-stemi-name"}
        title={ modalType + " STEMI Olympiad Name"}
        open={record}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={initWidth}
        footer={[
          <div className="modal-footer-buttons">
            <Button
              key="btn2-save-olympiad-name"
              type="primary"
              htmlType="submit"
              onSubmit={onSubmit}
              form={formName}
            >
              Save
            </Button>
            <Popconfirm
              key="popconfirm-add-olympiad-name2"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={handleConfirm}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
          name={formName}
          onFinish={onSubmit}
        >
          {modalType === "Edit" && (
            <>
              <Form.Item
                name="name"
                label="Olympiad Name"
                rules={[
                  {
                    required: true,
                    message: "Please provide olympiad name",
                  },
                ]}
              >
                <Input name="value" minLength={2} />
              </Form.Item>
              <Form.Item
                valuePropName="checked"
                name="active"
                label="Active Name?"
                rules={[{ required: false }]}
              >
                <CheckboxSwitchery checked={activeName} disabled={false} onChange={onChangeActive} />
              </Form.Item>
            </>
          )}
          {modalType === "Add" && (
            <Form.Item
              name="names"
              label="Olympiad Names"
              rules={[
                {
                  required: true,
                  message: "Please provide olympiad name",
                },
              ]}
            >
              <FormItemList name={"names"} buttonLabel={"Add Name"} placeholder="STEMI Olympiad Name" />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default ManageOlympiadName;
